'use client';

import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies';
import Script from 'next/script';

import { useEffect } from 'react';

import { GrowthBookPayload } from '@growthbook/growthbook-react';

import { commonUiStateSlice, useAppDispatch } from '@app/app-state';
import { GrowthbookAppProvider } from '@app/components/providers/growthbook-provider';
import { handleCookiesAppRouter } from '@app/state/helpers/cookie-app-router.helpers';
import { ThemeProviderWithCache } from '@app/ui-providers';
import { I18nProvider } from '@app/ui-providers/i18n-provider';

import speculationRules from '../public/speculation-rules.json';

export default function ClientLayout({
    isSession,
    cookies,
    children,
    growthbookPayload,
}: {
    isSession: boolean;
    cookies: RequestCookie[];
    children: React.ReactNode;
    growthbookPayload: GrowthBookPayload | null;
}) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(commonUiStateSlice.initPage());
        handleCookiesAppRouter({ isSession, cookies }, dispatch);
    }, []);

    return (
        <>
            <I18nProvider>
                <ThemeProviderWithCache>
                    <GrowthbookAppProvider payload={growthbookPayload}>
                        {children}
                    </GrowthbookAppProvider>
                </ThemeProviderWithCache>
            </I18nProvider>
            <Script
                id="speculation-rules"
                type="speculationrules"
                strategy="lazyOnload"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(speculationRules),
                }}
            />
        </>
    );
}
